import { faqCelular, faqCusto, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const corretor: ProfessionPageConfig = {
  path: '/ia-para-corretor-de-imoveis/',
  key: 'corretor',
  title: 'IA para corretor de imóveis: o que dá para fazer hoje | Oficina IA',
  description:
    'Três tarefas do dia a dia do corretor que a IA pode adiantar no seu computador: lista fria, descrição de imóveis e acompanhamento de clientes.',
  imageAlt: 'Oficina IA: IA para corretor de imóveis',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para corretor de imóveis e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para corretor de imóveis',
  intro:
    'Corretor passa o dia entre ligações, mensagens e papel. Eu trabalhei em imobiliária e sei o tamanho da pilha. Aqui estão três tarefas que a IA pode ajudar a adiantar, sem programar e sem mudar o jeito como você atende.',
  rogerio: { pose: 'animado', text: 'Cada folha de lista fria é um novelo. Dá para desenrolar.' },
  tasks: [
    {
      title: 'Lista fria sem repetidos',
      tone: 'sky',
      brings: 'as folhas da lista fria, fotografadas com o celular.',
      helps: 'lê as fotos, junta tudo numa planilha e aponta quem aparece duas vezes.',
      continues: 'uma lista limpa para ligar, com uma aba do que ficou em dúvida.',
    },
    {
      title: 'Descrição de imóveis',
      tone: 'peach',
      brings: 'as fotos e a ficha do imóvel, com o que você fala na visita.',
      helps: 'escreve a descrição do seu jeito: uma para o portal, uma para o WhatsApp.',
      continues: 'lê, corrige o que só você sabe e publica.',
    },
    {
      title: 'Acompanhamento de clientes',
      tone: 'sage',
      brings: 'suas anotações de quem pediu retorno e quando.',
      helps: 'monta uma lista simples do que fazer hoje, por ordem.',
      continues: 'um controle seu, que você entende e retoma na semana seguinte.',
    },
  ],
  steps: {
    do: 'A IA prepara a planilha, o texto ou a lista dentro da sua pasta.',
    check: 'Abra o que saiu e compare com o papel. A IA pode se enganar; a decisão é sua.',
    resume: 'Na semana seguinte, troque as fotos ou a lista e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'A IA vai falar com os meus clientes?',
      answer: 'Nas tarefas desta página, quem fala com o cliente é você. A IA prepara a lista, o texto e a organização. A conversa continua sua.',
    },
    faqCelular,
    faqCusto,
  ],
  closing: {
    title: 'Sua primeira lista, com alguém do lado.',
    text: 'Traga a lista fria, a descrição que travou ou o cliente que ficou sem retorno.',
    rogerio: 'Eu cuido do novelo. Você cuida da venda.',
  },
}
